module.exports = __webpack_public_path__ + "img/undraw_programming_re_kg9v.96565d32.svg";